import React, { useEffect, useRef, useState } from "react";
import moment from "jalali-moment";
import { useReactToPrint } from "react-to-print";
import generatePDF from "react-to-pdf";
import { useLocation, useNavigate } from "react-router";
import { digitsThree } from "../../../utils/price";

const PdfAndPrint = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "print order",
    bodyClass: "rtlDir",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });

  const location = useLocation();

  const [data, setData] = useState();

  useEffect(() => {
    if (location?.state?.products?.length) {
      setData(location?.state);
    }
  }, [location.state]);

  console.log(location.state);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location?.pathname]);

  const orderInfoRef = useRef();
  const handleOrderInfoPrint = useReactToPrint({
    contentRef: orderInfoRef,
    documentTitle: "print order info",
    bodyClass: "rtlDir",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });

  return (
    <div className="w-[1024px] mx-auto h-auto py-10 bg-white">
      <div className="flex items-center justify-between px-4">
        <div className="w-11/12 flex gap-3 items-center mx-auto">
          <button
            onClick={handlePrint}
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            پرینت سفارش
          </button>
          <button
            onClick={handleOrderInfoPrint}
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            پرینت اطلاعات ارسال
          </button>
          <button
            onClick={() => generatePDF(componentRef, { filename: "page.pdf" })}
            type="button"
            className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            دانلود PDF
          </button>
        </div>
        <p
          onClick={() => navigate(-1)}
          className="cursor-pointer focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
        >
          بازگشت
        </p>
      </div>
      <div className="w-full p-4">
        <div ref={componentRef} className="w-full overflow-hidden">
          <div className="w-full flex justify-between p-4">
            <div className="flex items-cneter justify-center w-48">
              <p>
                <img
                  className="w-20 py-2"
                  src={"/logo192.png"}
                  alt="website-logo"
                />
              </p>
            </div>
            <div className="text-xl text-gray-800 b-titr">
              فروشگاه عطار باشی
            </div>
            <div className="flex flex-col w-48 text-gray-800 text-sm justify-center gap-1 b-titr">
              <p>تاریخ : {moment().locale("fa").format("YYYY/M/D")}</p>
              <p>شماره فاکتور : #{data?.trackingCode}</p>
              <p>تلفن فروشگاه : 01134569856</p>
            </div>
          </div>

          <h3 className="px-2 text-gray-800 w-full text-center mb-2">
            مشخصات کالا
          </h3>
          <div className="w-full px-8">
            <div className="flex flex-col">
              <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full border border-neutral-300 text-center text-sm font-light text-surface dark:border-white/10 dark:text-white">
                      <thead className="border-b border-neutral-300 font-medium dark:border-white/10">
                        <tr>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            ردیف
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            شرح کالا
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            تعداد
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            مبلغ واحد
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            مبلغ کل
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            درصد تخفیف
                          </th>
                          <th
                            scope="col"
                            className="border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs"
                          >
                            مبلغ نهایی
                          </th>
                          <th scope="col" className="px-6 py-4">
                            QC
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.products?.map((item, index) => {
                          return (
                            <tr className="border-b border-neutral-300 dark:border-white/10">
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 font-medium dark:border-white/10">
                                {index + 1}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {item.productName}
                                {item?.isGift ? " - هدیه" : ""}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {item.count}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {digitsThree(item.basePrice)}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {digitsThree(item.totalPrice)}
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                0
                              </td>
                              <td className="whitespace-nowrap border-e border-neutral-300 px-6 py-4 dark:border-white/10 text-xs">
                                {digitsThree(item.totalPrice)}
                              </td>
                              <td className="whitespace-nowrap px-6 py-4 flex justify-center items-center">
                                <div className="border w-4 h-4 border-gray-600 rounded-sm"></div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    <div className="flex justify-between gap-4 p-4 px-10 w-full border mt-4 text-gray-800">
                      <div className="flex flex-col gap-4">
                        <p>تخفیف کل : 0 </p>
                        <p>
                          مجموع قیمت کالا :{" "}
                          {digitsThree(data?.totalProductsPrice)}
                        </p>
                      </div>
                      <div className="flex flex-col gap-4">
                        <p>
                          هزینه ارسال :{" "}
                          {data?.shippingTotalPrice
                            ? `${digitsThree(data?.shippingTotalPrice)} `
                            : "رایگان"}
                        </p>
                        <p>
                          مجموع پرداختی :{" "}
                          {digitsThree(
                            data?.totalProductsPrice + data?.shippingTotalPrice
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-3 border-t border-b boder-gray-900 py-2"></div>
        <div ref={orderInfoRef} className="w-full px-2 py-4 a5-print">
          <h3 className="px-2 text-gray-800">اطلاعات مشتری</h3>
          <div className="flex flex-col gap-3 text-gray-700 py-4">
            <div className="flex px-4 iems-center gap-4">
              <p className="w-6/12 text-md">
                نام و نام خانوادگی : {data?.name}
              </p>
              <p className="w-6/12 text-md">شماره تماس : {data?.mobile}</p>
            </div>
            <div className="flex px-4 iems-center gap-4">
              <p className="w-6/12 text-md">کد پستی : {data?.postcode}</p>
              <p className="w-6/12 text-md">
                استان و شهر : {data && `${data.province} - ${data.city}`}
              </p>
            </div>
            <div className="flex px-4 iems-center gap-4">
              <p className="w-6/12 text-md">
                شماره سفارش : {data && data.trackingCode}
              </p>
              <p className="w-6/12 text-md">
                آدرس : {data && `${data.address} `}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PdfAndPrint;
